import React, { useEffect, useState } from "react";
import { deadlineTypes } from "../../../constants/scadenze";
import { Select } from "antd";
import { FormattedMessage } from "react-intl";
const Option = Select.Option;

const  Type = ({ isSave, requestBody, setRequestBody}) => {
  const [typeError, setTypeError] = useState(false);

  const types = [];
  if (requestBody.scope === "fiscal_social_security") {
    deadlineTypes.map(item => {
      types.push(<Option value={item.key}>{item.desc}</Option>);
      return types;
    });
  } else {
    types.push(<Option value={"document"}>Documento</Option>);
    types.push(<Option value={"proforma"}>Proforma</Option>);
  }

  useEffect(() => {   
    if (!isSave) setTypeError(false);   
    else {
      setTypeError(!requestBody.type);      
    }
  }, [isSave]);

  useEffect(() => {
    if (!typeError) return;
    // if (!document.querySelector(".errorOccurs")) return;
    // faccio scrollare al primo elemento in errore
    document.querySelector(".errorOccurs")?.scrollIntoView();
  }, [typeError]);

  return ["fiscal_social_security", "studio_reminder"].includes(requestBody.scope) && (
    <div data-testid="container" className={typeError ? "errorOccurs" : ""}>
      <div data-testid="labelDialogContent" className="labelDialogContent">        
        <FormattedMessage id="deadlines.pages.create.type"/> *
      </div>
      <div className="customSelect largeSelect">
        <Select
          data-testid={"selectType"}
          getPopupContainer={trigger => trigger.parentNode}
          dropdownClassName="modalOverlay"
          size="large"
          value={requestBody.type}
          placeholder={<FormattedMessage id="deadlines.pages.create.type"/>}
          onChange={(value) => {
            setTypeError(false);
            setRequestBody({
              ...requestBody,
              type: value
            });
          }}
        >
          {types}
        </Select>
      </div>
    </div>
  );
};

export default Type;